module.exports = __webpack_public_path__ + "static/media/scissors.7640cc80.png";